module.exports = __webpack_public_path__ + "static/media/rekne.dbcad2b3.mp3";